import React from 'react';
import {_t} from "../../../js/app/common/utils/locale";

export default class FormErrorMessage extends React.Component {

    render() {
        if (this.props && this.props.message) {
            return (
                <div className="alert alert-danger">{_t(this.props.message)}</div>
            );
        }
        return null;
    }

}